import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function FeaturedSection() {
  const featured = articles.filter((a) => a.isFeatured).slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
              精选推荐
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              编辑团队精心挑选的优质内容，不容错过
            </p>
          </div>
          <Link
            to="/category/latest-recommend"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:translate-y-[-3px]"
            >
              <div className="relative overflow-hidden aspect-[16/9]">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full mb-2">
                    编辑精选
                  </span>
                  <h3 className="text-white text-lg font-semibold line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.viewCount.toLocaleString()}
                  </span>
                  <span>{article.publishDate}</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/latest-recommend"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
          >
            查看全部精选 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}